(function () {
  'use strict';
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    var flowerPath = document.getElementById('flowerPath');
    var reveal = document.querySelector('.line__flower-reveal');
    if (!flowerPath || !reveal) return;
    var len = 0;
    try { len = flowerPath.getTotalLength() || 0; } catch (e) {}
    if (!len) len = 12000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) {
      gsap.set(reveal, { strokeDasharray: 'none', strokeDashoffset: 0 });
      return;
    }
    gsap.set(reveal, { strokeDasharray: len, strokeDashoffset: len });
    gsap.to(reveal, {
      strokeDashoffset: 0,
      ease: 'power3.in',
      scrollTrigger: {
        trigger: '.line',
        start: 'top bottom+=80%',
        end: '+=340%',
        scrub: 0.8
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
